<template>
  <div  class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Cargar Movimientos</ModuleHeader>
      <MovimientosForm
        :membresia="membresia_id"
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData" />
    </div>
  </div>
</template>



<script>


import MovimientosForm from "../../Membresias/Movimientos/MovimientosForm.vue"
import TimeLinePagos from "../../MainComponents/Membresias/TimeLinePagos.vue"

export default {
  name: "MovimientosCRUD",
  components: {
    MovimientosForm,
  },
  props:['membresia_id'],
  data() {
    return {
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      showModal: false,
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol:{Field:"",Type:"Asc"},
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addMovimiento",
          },
          {
            text: "Ver reporte de movimientos",
            icon: "lni lni-list",
            buttonId: "reportMembresia",
          },
        ],
        fields: [
          {
            text: "Concepto",
            value: "Concepto",
          },
          {
            text: "Cantidad",
            value: "Cantidad",
          },
          {
            text: "Fecha",
            value: "Fecha",
          },
          {
            text: "Membresia",
            value: "Membresia",
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      data_movimentos: [],
      lastRecord:{},
    };
  },
  computed: {},
  methods: {
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createMovimiento(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addMovimiento") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Movimiento");
        this.toggleModal(true);
      }
      if (buttonId == "editarMembresia") {
        this.idSelected = idSelected[0];
        const cashier = this.$pgsHelper.getById(
          this.data_membresias,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cashier;
        this.$refs.modalForm.setTitle("Editar Membresia");
        this.toggleModal(true);
      }
      if (buttonId == "reportMembresia"){
        this.$router.push({ path: "/membresias/movimientos" });
      }
      if (buttonId == "deleteMembresia") {
        this.deleteCliente(idSelected[0]);
      }
    },
    async getMovimientos(nextPage = null) {
      //this.data_movimentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filters  = [
        firestore.where("Tenant", "==", this.$store.getters.getFirebaseApp.tenant)
      ];
      if (this.membresia_id) {
        filters.push(firestore.where("Membresia", "==", this.membresia_id));
      }
      filters.push(firestore.orderBy("Fecha","desc"));
      filters.push(firestore.orderBy("FechaCreacion","desc"));
      filters.push(firestore.limit(5));
      if(nextPage){
        filters.push(firestore.startAfter(this.lastRecord));
      }
      const data = await firestore.queryBuilder(
        "MBS_Movimientos",
        filters
      );

      let movimientos = data.docs.map((doc) => {
        this.lastRecord = doc
        return { id: doc.ref.id, ...doc.data() };
      });
      if(nextPage){
        this.data_movimentos = this.data_movimentos.concat(movimientos);
      }else{
        this.data_movimentos = movimientos;
      }
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    createMovimiento(data) {
      this.$swal({
        title: "¿Deseas guardar el movimiento?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Movimientos-createMovimiento", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Movimiento se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.getMovimientos()
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving movimiento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {

  },
};
</script>